import { render, staticRenderFns } from "./WhyOneOrder.vue?vue&type=template&id=cb2c1286"
import script from "./WhyOneOrder.vue?vue&type=script&lang=js"
export * from "./WhyOneOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports